var mobileStyle = false;
var mobileStyleA = false;

$(document).ready(function(){
    $("#mcOptions1").on("change",function(){
        if($(this).val() == "b"){
            $("#mcItem1").attr("src", "//denisealbright.com/cdn/shop/t/40/assets/arti3_prod01b.png?v=33066975723118506701772549798");
            $("#mcItem2").attr("src", "//denisealbright.com/cdn/shop/t/40/assets/arti3_prod02b.png?v=11760397473267127271772549798");
            $("#mcItem3").attr("src", "//denisealbright.com/cdn/shop/t/40/assets/arti3_prod03b.png?v=114942850673282427551772549798");
            mobileStyle = true;
        }else{
            $("#mcItem1").attr("src", "//denisealbright.com/cdn/shop/t/40/assets/arti3_prod01.png?v=60965808524458765191772549798");
            $("#mcItem2").attr("src", "//denisealbright.com/cdn/shop/t/40/assets/arti3_prod02.png?v=161968166883654035671772549798");
            $("#mcItem3").attr("src", "//denisealbright.com/cdn/shop/t/40/assets/arti3_prod03.png?v=156108921077721495581772549798");
            mobileStyle = false;
        }
    })
    $('#mcItemOption3').on('change', function(){
        if($(this).val() == "b"){
            $('#of3op1IMG').attr('src', '//denisealbright.com/cdn/shop/t/40/assets/arti3_prod03b.png?v=114942850673282427551772549798');
            mobileStyleA = true;
        }else{
            $('#of3op1IMG').attr('src', '//denisealbright.com/cdn/shop/t/40/assets/arti3_prod03.png?v=156108921077721495581772549798');
            mobileStyleA = false
        }
    })
    $('#mcItemOption2').on('change', function(){
        if($(this).val() == "b"){
            $('#of2op1IMG').attr('src', '//denisealbright.com/cdn/shop/t/40/assets/arti3_prod02b.png?v=11760397473267127271772549798');
            mobileStyleA = true;
        }else{
            $('#of2op1IMG').attr('src', '//denisealbright.com/cdn/shop/t/40/assets/arti3_prod02.png?v=161968166883654035671772549798');
            mobileStyleA = false
        }
    })

    $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        $('#bottom-floating-bar').toggleClass('ok', scroll >= $('.mark').offset().top);
    });
    //trigger the scroll
    $(window).scroll();//ensure if you're in current position when page is refreshed
    $(document).scroll(function() {
        var y = $(this).scrollTop();
        if (y > 820) {
            $('#bottom-floating-bar').fadeIn();
        } else {
            $('#bottom-floating-bar').fadeOut();
        }
    });

    
});

// SlideDown Toggle
jQuery("#closebox1").click(function() {
    $(".mcModalsz").removeClass("active");
    $(".modalz").removeClass("active");
});
jQuery(".descListbtn").click(function() {
    $( ".desc-list" ).slideToggle( "slow" );
});

  // FOMO PopUp //
  
  window.onload = function () {
    city();
    photoStick();
}

function city() {
    Array.prototype.random = function (length) {
        return this[Math.floor((Math.random() * length))];
    }
    let cities = [" San Diego, CA ", " Denver, CO ", " Miami, FL ", " Austin, TX ", " Boise, ID ", " Seattle, WA ", " Atlanta, GA ", " Akron, OH ", " Detroit, MI ", " Richmond, VA ", " Portland, ME ", " Charleston, SC ", " Davenport, IA ", " Dover, DE ", " Rogers, AK " ]
    let chosenCity = cities.random(cities.length);

    $("#place").html(chosenCity);
}

function photoStick() {
    Array.prototype.random = function (length) {
        return this[Math.floor((Math.random() * length))];
    }
    let product = [" ThePhotoStick 64GB ", " ThePhotoStick 128GB ", " ThePhotoStick Plus 1TB "]
    let chosenProduct = product.random(product.length);

    $("#pStick").html(chosenProduct);
}


setInterval(function () {
    Array.prototype.random = function (length) {
        return this[Math.floor((Math.random() * length))];
    }
    let number = [ 12000, 25000, 30000, 35000, 40000, 45000]
    let randomNumber = number.random(number.length);

    $("#popUp").css('visibility', 'visible').animate({
        opacity: 1.0,
        bottom: "0px"
    }, "fast").delay(8000);

    $("#popUp").animate({
        opacity: 0.0,
        "bottom": "-20px"
    }, "fast", setInvisible).delay(randomNumber);

}, 6000);

function setInvisible() {
    city();
    photoStick();

    $('#popUp').css('visibility', 'hidden').css('visibility', 'visible');
}

// END FOMO PopUp //

$(document).ready(function () {
    //called when key is pressed in textbox
    $(".numbersOnly").keypress(function (e) {
       //if the letter is not digit then display error and don't type anything
       if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
          //display error message
                 return false;
      }
     });
  
  });
  
  // FAQ Accordion //
  
  $('.faqLink').click(function() {
      $( ".faqForm" ).slideToggle( "slow", function() {
            });
  });
  
  $('.clickSection').click(function() {
  
      $(this).next().slideToggle(350);
  
  });
  
  // END FAQ Accordion // 
    
    // Modal Popup
    // Get the modal
    var modal = document.getElementById('myModal');
  
    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("closeme")[0];
    
    // Find and Count The Buy Buttons elements 
    var x = document.getElementsByClassName("c-buymenow");
    var i;
    for (i = 0; i < x.length; i++) {
      // When the user clicks on the button, open the modal 
      x[i].onclick = function() {
        modal.style.display = "block";
      }
    }
    // When the user clicks on <span> (x), close the modal
    span.onclick = function() {
      modal.style.display = "none";
    }
  
    
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    }
    
    // End Modal
  
  
  
  
  $('input[name=zsize]').change(function()  {
      // change the page per this logic
      switch ($('input[name=zsize]:checked').val()) {
          case '1':
  
          break;
  
          case '2':
  
          break;
  
          case '3':
  
          break;
  
          case '4':
  
          break;
  
          case '5':
  
          break;
  
          default:
  
          break;
      };
  });
  
  /*
  *
  * 8 - a - 3rd Place - Last
  *
  */
$(document).ready(function(){ 
    var cccode = ""
    var offerA;
    var offerA1Style = ""
    var offerA2Style = ""
    var $site = "https://denise-albright.myshopify.com/cart/";
    var $discount = "&discount=AMARB2102";
    var $pa = "37020502261960:1"; //
    var $pa1 = "37020502294728:1"; //
    var $oa1a = ",37020502261960:1"; // Stripes
    var $oa1b = ",37020502294728:1"; // Chevron
    var $oa2a = ",37020516450504:1"; // up
    var $oa2b = ""; // up

    
        // $('#optAStyle1').on('change', function(){
        //     $('#imgPack1').attr('src', $(this).val() + '.png' | asset_url }}');
        // });
        $('#optAStyle1').on('change', function(){
            if($(this).val() == "b"){
                $('#imgPack1').attr('src', '//denisealbright.com/cdn/shop/t/40/assets/arti3_prod03b.png?v=114942850673282427551772549798');
                offerA = $pa;
            }else{
                $('#imgPack1').attr('src', '//denisealbright.com/cdn/shop/t/40/assets/arti3_prod03.png?v=156108921077721495581772549798');
                offerA = $pa1;
            }
        });

        $('#optAStylea').on('change', function(){
            if($(this).val() == "b"){
                $('#offerImg1').attr('src', '//denisealbright.com/cdn/shop/t/40/assets/arti3_prod03b.png?v=114942850673282427551772549798');
            }else{
                $('#offerImg1').attr('src', '//denisealbright.com/cdn/shop/t/40/assets/arti3_prod03.png?v=156108921077721495581772549798');
            }
        });
    
        $('.packContainer1 .c-buymenow').click(function () { // Android
            $(".packContainer1").addClass('active');
            $(".packContainer2").removeClass('active');
            $(".packContainer3").removeClass('active');
            $("#btnSelect1").hide();
            $("#btnSelected1").show();
            $("#btnSelected2").hide();
            $("#btnSelected3").hide();
            $("#btnSelect2").show();
            $("#btnSelect3").show();
    
            $("#c-opt-d").hide();
            $("#c-opt-i").hide();
            $("#c-opt-a").show(); //.slideDown();

            var offerAval0 = $('#optAStyle1').val();
            if(offerAval0 == "a"){
                offerA = $pa
            }else if(offerAval0 == "b"){
                offerA = $pa1
            }
        
        })

        $("#c-opt-a .goNext").click(function (ev) {
            ev.preventDefault() // cancel form submission
            var offerAval1;
            if ($(this).attr("value") == "Yes, I Want This!") {
                
                cccode = $discount;

                var offerAval1 = $('#optAStylea').val();// Box ID    

                if(offerAval1 == "a"){
                    offerA1Style = $oa1a
                }else if(offerAval1 == "b"){
                    offerA1Style = $oa1b
                }
            }
            if ($(this).attr("value") == "No, I don't like savings.") {
            
            }
            $("#c-opt-a .c-moreoptionsA").hide();
            $("#c-opt-a .c-moreoptionsb").slideDown();
        });

        $("#c-opt-a .letsgo").click(function (ev) {
            ev.preventDefault() // cancel form submission
            
            if ($(this).attr("value") == "Yes, I Want This!") {
                offerA2 = 1
                    offerA2Style = $oa2a

                // var offerAval2 = $('#optAStyleb').val(); // Box ID
                // if(offerAval2 == "a"){
                //     offerA2Style = $oa2a
                // }else if(offerAval2 == "b"){
                //     offerA2Style = $oa2b
                // }

                document.location.href = ""+$site+offerA+offerA1Style+offerA2Style+"?channel=buy_button"+cccode; 
            
            }
            if ($(this).attr("value") == "No, I don't like savings.") {
                offerA2 = 0;

                document.location.href = ""+$site+offerA+offerA1Style+"?channel=buy_button"+cccode; 
            }
            $(".letsgo").hide();
            $(".coptloading").css('display','block');

        });
  });
  
  
  
  /*
  *
  * 64 - i - 2nd Place - Middle
  *
  */
  $(function () {
    var cccode = ""
    var offerB;
    var offerB1Style = ""
    var offerB2Style = ""
    var $site = "https://denise-albright.myshopify.com/cart/";
    var $discount = "&discount=AMARB2101";
    var $pi = "37020486172872:1"; //
    var $pi1 = "37020486205640:1"; //
    var $oi1a = ",37020486172872:1"; // Stripes
    var $oi1b = ",37020486205640:1"; // Chevron
    var $oi2a = ",36604394242201:1"; // up
    var $oi2b = ""; // up
    
        // $('#optAStyle2').on('change', function(){
        //     $('#imgPack2').attr('src', $(this).val() + '.png' | asset_url }}');
        // });
        $('#optAStyle2').on('change', function(){
            if($(this).val() == "b"){
                $('#imgPack2').attr('src', '//denisealbright.com/cdn/shop/t/40/assets/arti3_prod02b.png?v=11760397473267127271772549798');
                offerB = $pi;
            }else{
                $('#imgPack2').attr('src', '//denisealbright.com/cdn/shop/t/40/assets/arti3_prod02.png?v=161968166883654035671772549798');
                offerB = $pi1;
            }
        });

        $('#optIStylea').on('change', function(){
            if($(this).val() == "b"){
                $('#offerImg2').attr('src', '//denisealbright.com/cdn/shop/t/40/assets/arti3_prod02b.png?v=11760397473267127271772549798');
                
            }else{
                $('#offerImg2').attr('src', '//denisealbright.com/cdn/shop/t/40/assets/arti3_prod02.png?v=161968166883654035671772549798');
            }
        });
        $('.packContainer2 .c-buymenow').click(function () { // Mac
            $(".packContainer2").addClass('active');
            $(".packContainer1").removeClass('active');
            $(".packContainer3").removeClass('active');
            $("#btnSelect2").hide();
            $("#btnSelected2").show();
            $("#btnSelected1").hide();
            $("#btnSelected3").hide();
            $("#btnSelect1").show();
            $("#btnSelect3").show();
        
            $("#c-opt-d").hide();
            $("#c-opt-a").hide();
            $("#c-opt-i").show(); //.slideDown(); fadeIn("fast");
        
            var offerBval0 = $('#optAStyle2').val();
            if(offerBval0 == "a"){
                offerB = $pi
            }else if(offerBval0 == "b"){
                offerB = $pi1
            }
        })

        $("#c-opt-i .goNext").click(function (ev) {
            ev.preventDefault() // cancel form submission
            var offerBval1;
            if ($(this).attr("value") == "Yes, I Want This!") {
                
                cccode = $discount;

                var offerBval1 = $('#optIStylea').val();// Box ID    
                if(offerBval1 == "a"){
                    offerB1Style = $oi1a
                }else if(offerBval1 == "b"){
                    offerB1Style = $oi1b
                }
            }
            if ($(this).attr("value") == "No, I don't like savings.") {
            
            }
            $("#c-opt-i .c-moreoptionsA").hide();
            $("#c-opt-i .c-moreoptionsb").slideDown();
        });

        $("#c-opt-i .letsgo").click(function (ev) {
            ev.preventDefault() // cancel form submission
            
            if ($(this).attr("value") == "Yes, I Want This!") {

                offerB2Style = $oi2a
                
                // var offerBval2 = $('#optAStyleb').val(); // Box ID
                // if(offerBval2 == "a"){
                //     offerB2Style = $oi2a
                // }else if(offerBval2 == "b"){
                //     offerB2Style = $oi2b
                // }

                document.location.href = ""+$site+offerB+offerB1Style+offerB2Style+"?channel=buy_button"+cccode; 
            
            }
            if ($(this).attr("value") == "No, I don't like savings.") {
                offerB2 = 0;

                document.location.href = ""+$site+offerB+offerB1Style+"?channel=buy_button"+cccode; 
            }
            $(".letsgo").hide();
            $(".coptloading").css('display','block');

        });
  });
  
  
  /*
  *
  * 128 - d - 1st Place - left SIDE - d
  *
  */
  $(function () {
    var offerC;
    var offerC1Style = ""
    var offerC2Style = ""
    var $site = "https://denise-albright.myshopify.com/cart/";
    var $pd = "37020294709448:1"; //
    var $pd1 = "37020294742216:1"; //
    var $od1a = ",37020517564616:1"; // Stripes
    var $od1b = ""; // Chevron
    var $od2a = ",36604394242201:1"; // up
    var $od2b = ""; // up

    
        // $('#optAStyle3').on('change', function(){
        //     $('#imgPack3').attr('src', $(this).val() + '.png' | asset_url }}');
        // });

        $('#optAStyle3').on('change', function(){
            if($(this).val() == "b"){
                $('#imgPack3').attr('src', '//denisealbright.com/cdn/shop/t/40/assets/arti3_prod01b.png?v=33066975723118506701772549798');
                offerC = $pd
            }else{
                $('#imgPack3').attr('src', '//denisealbright.com/cdn/shop/t/40/assets/arti3_prod01.png?v=60965808524458765191772549798');
                offerC = $pd1
            }
        });

        $('#optDStylea').on('change', function(){
            if($(this).val() == "b"){
                $('#offerImg3').attr('src', '//denisealbright.com/cdn/shop/t/40/assets/arti3_prod01b.png?v=33066975723118506701772549798');
            }else{
                $('#offerImg3').attr('src', '//denisealbright.com/cdn/shop/t/40/assets/arti3_prod01offer2.png?v=135308318950502355931772549798');
            }
        });

        $('.packContainer3 .c-buymenow').click(function () { // Desktop
            $(".packContainer3").addClass('active');
            $(".packContainer1").removeClass('active');
            $(".packContainer2").removeClass('active');
            $("#btnSelect3").hide();
            $("#btnSelected3").show();
            $("#btnSelected1").hide();
            $("#btnSelected2").hide();
            $("#btnSelect1").show();
            $("#btnSelect2").show();
        
            $("#c-opt-i").hide();
            $("#c-opt-a").hide();
            $("#c-opt-d").show(); //.slideDown();fadeIn("fast");

            var offerCval0 = $('#optAStyle3').val();
            if(offerCval0 == "a"){
                offerC = $pd
            }else if(offerCval0 == "b"){
                offerC = $pd1
            }
        
        })

        $("#c-opt-d .goNext").click(function (ev) {
            ev.preventDefault() // cancel form submission
            var offerCval1;
            if ($(this).attr("value") == "Yes, I Want This!") {

                offerC1Style = $od1a
                // var offerCval1 = $('#optAStylea').val();// Box ID    
                // if(offerCval1 == "a"){
                //     offerC1Style = $od1a
                // }else if(offerCval1 == "b"){
                //     offerC1Style = $od1b
                // }
            }
            if ($(this).attr("value") == "No, I don't like savings.") {
            
            }
            $("#c-opt-d .c-moreoptionsA").hide();
            $("#c-opt-d .c-moreoptionsb").slideDown();
        });

        $("#c-opt-d .letsgo").click(function (ev) {
            ev.preventDefault() // cancel form submission
            
            if ($(this).attr("value") == "Yes, I Want This!") {
                offerC2 = 1
                // var offerCval2 = $('#optAStyleb').val(); // Box ID

                // if(offerCval2 == "a"){
                //     offerC2Style = $od2a
                // }else if(offerCval2 == "b"){
                //     offerC2Style = $od2b
                // }
                
                offerC2Style = $od2a
                document.location.href = ""+$site+offerC+offerC1Style+offerC2Style+"?channel=buy_button"; 
            
            }
            if ($(this).attr("value") == "No, I don't like savings.") {
                offerC2 = 0;

                document.location.href = ""+$site+offerC+offerC1Style+"?channel=buy_button"; 
            }
            $(".letsgo").hide();
            $(".coptloading").css('display','block');

        });
});





  $('input[name=asize]').change(function()  {
      // change the page per this logic
      switch ($('input[name=asize]:checked').val()) {
          case '32':
              $('#packContainer1 #price').text('64.95');
              $('#packContainer1 #oldprice').text('99.99');
              $('#packContainer1 #savings').text('35.00');
              break;
          case '64':
              $('#packContainer1 #price').text('98.99');
              $('#packContainer1 #oldprice').text('159.99');
              $('#packContainer1 #savings').text('61.00');
              break;
          case '128':
              $('#packContainer1 #price').text('120.99');
              $('#packContainer1 #oldprice').text('199.99');
              $('#packContainer1 #savings').text('79.00');
              break;
          default:
              $('#packContainer1 #price').text('64.95');
              $('#packContainer1 #oldprice').text('99.99');
              $('#packContainer1 #savings').text('35.00');
              break;
      };
  });
  
  $('input[name=isize]').change(function()  {
      // change the page per this logic
      switch ($('input[name=isize]:checked').val()) {
          case '32':
              $('#packContainer2 #price').text('64.95');
              $('#packContainer2 #oldprice').text('99.99');
              $('#packContainer2 #savings').text('35.00');
              break;
          case '64':
              $('#packContainer2 #price').text('98.99');
              $('#packContainer2 #oldprice').text('159.99');
              $('#packContainer2 #savings').text('61.00');
              break;
          case '128':
              $('#packContainer2 #price').text('120.99');
              $('#packContainer2 #oldprice').text('199.99');
              $('#packContainer2 #savings').text('79.00');
              break;
          default:
              $('#packContainer2 #price').text('64.95');
              $('#packContainer2 #oldprice').text('99.99');
              $('#packContainer2 #savings').text('35.00');
              break;
      };
  });
  
  $('input[name=dsize]').change(function()  {
      // change the page per this logic
      switch ($('input[name=dsize]:checked').val()) {
          case '32':
              $('#packContainer3 #price').text('34.99');
              $('#packContainer3 #oldprice').text('49.99');
              $('#packContainer3 #savings').text('15.00');
              break;
          case '64':
              $('#packContainer3 #price').text('49.99');
              $('#packContainer3 #oldprice').text('79.99');
              $('#packContainer3 #savings').text('30.00');
              break;
          case '128':
              $('#packContainer3 #price').text('79.99');
              $('#packContainer3 #oldprice').text('159.99');
              $('#packContainer3 #savings').text('80.00');
              break;
          default:
              $('#packContainer3 #price').text('34.99');
              $('#packContainer3 #oldprice').text('49.99');
              $('#packContainer3 #savings').text('15.00');
              break;
      };
  });



  
  

  /// Mobile Modals
  
        
  // assigns overlay container to a variable
  let overlay = document.querySelector('.mcModals');
  // find all modals on page, adds them to an object
  let modals = document.getElementsByClassName('modal');
  let modalz = document.getElementsByClassName('modalz');
  // gets all item contianers
  let items = document.getElementsByClassName('item');
  // find all items on page, adds them to an object
  let itemSelects = document.getElementsByClassName('itemSelect');
  // find all items on page, adds them to an object
  let soAmounts = document.getElementsByClassName('soCount');
  // creates empty variable for currently open modal
  let currentModal;
  // checkout url
  const checkout = "https://denise-albright.myshopify.com/cart/";
  // creates object for needed Shopify URLs
  const urls = [
      {default: "37020294709448:1"},
      {default: "37020486172872:1"},
      {default: "37020502261960:1"}
  ]

  var mycart = [];
  
  // opens associated modal based on the product that is checked
  function soBtnHandlerNext(box, offer1) {    
    $("#"+box+" .mOffer1").hide();
    $("#"+box+" .mOffer2").slideDown();    
    
    if(offer1){
        var item = {prod: offer1}
        mycart.push (item);
    }
  }

  function orderBtnHandler() {
      event.preventDefault();
      if (itemSelects[0].checked) {
          overlay.classList.add('active');
          modals[0].classList.add('active');
          currentModal = modals[0];
      }
      if (itemSelects[1].checked) {
          overlay.classList.add('active');
          modals[1].classList.add('active');
          currentModal = modals[1];
      }
      if (itemSelects[2].checked) {
          overlay.classList.add('active');
          modals[2].classList.add('active');
          currentModal = modals[2];
      }
  }

  // checks the item you click
  function itemHandler(clicked_id) {
      let item = document.getElementById(clicked_id);
      let itemInput = item.querySelector('.itemSelect');
      itemInput.checked = true;      
  }

  // handles user input on counters
  function countChangeHandler(parent) {
      let input = parent.querySelector('input');
      let currentValue = input.value;
  }
  
  // up counter
  function counterUp(parent) {
      parent.querySelector('input').stepUp();
      countChangeHandler(parent);
  }

  // down counter
  function counterDown(parent) {
      parent.querySelector('input').stepDown();
      countChangeHandler(parent);
  }


  function soBtnHandler(offer2) {
      var myopt;
      
      if (currentModal === modals[0]) {
        //   document.location.href = checkout + urls[0].default + urls[0].special;
            if (mobileStyle == true){ myopt = "37020294742216:1"} else{myopt =  urls[0].default;}

            if(offer2){
                var item = {prod: offer2}
                mycart.push (item);
                
            }

            switch(mycart.length) {
                case 1:
                    opt0 =  mycart[0].prod;
                    document.location.href = checkout + myopt+","+opt0+"?channel=buy_button"
                    break;

                case 2:
                    opt0 =  mycart[0].prod;
                    opt1 =  mycart[1].prod;
                    document.location.href = checkout + myopt+","+opt0+","+opt1+"?channel=buy_button"
                    break;

                default:
                    document.location.href = checkout + myopt+"?channel=buy_button"
            }
      }


      if (currentModal === modals[1]) {

            var salesChanel = "?channel=buy_button";
            //   document.location.href = checkout + urls[1].default + urls[1].special;
            if (mobileStyle == true){ myopt = "37020486205640:1"} else{myopt =  urls[1].default;}
            if (mycart.length > 0){
                if (mobileStyleA == false){ mycart[0].prod = urls[1].default;} else if(mobileStyleA == true){mycart[0].prod = "37020486205640:1"}
                salesChanel = "?channel=buy_button&discount=AMARB2101";
            }
            
            if(offer2){               
                var item = {prod: offer2}
                mycart.push (item);
            }

            switch(mycart.length) {
                case 1:
                    opt0 =  mycart[0].prod;
                    document.location.href = checkout + myopt+","+opt0+salesChanel
                    break;

                case 2:
                    opt0 =  mycart[0].prod;
                    opt1 =  mycart[1].prod;
                    document.location.href = checkout + myopt+","+opt0+","+opt1+salesChanel
                    break;

                default:
                    document.location.href = checkout + myopt+salesChanel
            }

      }

      if (currentModal === modals[2]) {

        //   document.location.href = checkout + urls[2].default + urls[2].special;
        var salesChanel = "?channel=buy_button";
        //   document.location.href = checkout + urls[2].default + urls[2].special;
        if (mobileStyle == true){ myopt = "37020502294728:1"} else{myopt =  urls[2].default;}
        if (mycart.length > 0){
            if (mobileStyleA == false){ mycart[0].prod = urls[2].default;} else if(mobileStyleA == true){mycart[0].prod = "37020502294728:1"}
            salesChanel = "?channel=buy_button&discount=AMARB2102";
        }
        
        if(offer2){               
            var item = {prod: offer2}
            mycart.push (item);
        }

        switch(mycart.length) {
            case 1:
                opt0 =  mycart[0].prod;
                document.location.href = checkout + myopt+","+opt0+salesChanel
                break;

            case 2:
                opt0 =  mycart[0].prod;
                opt1 =  mycart[1].prod;
                document.location.href = checkout + myopt+","+opt0+","+opt1+salesChanel
                break;

            default:
                document.location.href = checkout + myopt+salesChanel
        }        

      }
      $(".mcModals .modal .mOffer .noThanks").hide();
      $(".mcModals .btn").hide();
      $(".coptloading").show();
  }

  // handles the closing of all modals
  function closeHandler() {
      overlay.classList.remove('active');
      currentModal.classList.remove('active');
      currentModal = null;
      mycart = [];
      mobileStyleA = false;
      
  }


